export {
  SpeechRecognitionController,
  type SpeechRecognitionControllerOptions,
  type SpeechRecognitionErrorEventLike,
  type SpeechRecognitionLike,
  type SpeechRecognitionResultEventLike,
  type VoiceControllerErrorDetail,
  type VoiceControllerErrorType,
  type VoiceControllerState,
  type VoiceControllerStateDetail,
  type VoiceControllerTranscriptDetail,
} from './controllers/speech-recognition-controller';

export {
  VoiceCaptureElement,
  type VoiceCaptureErrorDetail,
  type VoiceCaptureErrorType,
  type VoiceCaptureMessageOverrides,
  type VoiceCaptureMessages,
  type VoiceCaptureProcessedDetail,
  type VoiceCaptureRequestPayload,
  type VoiceCaptureRequestResult,
  type VoiceCaptureState,
  type VoiceCaptureUiLocale,
} from './components/voice-capture';

export {
  normalizeVoiceCaptureLocale,
  resolveVoiceCaptureMessages,
  voiceCaptureMessagesByLocale,
} from './i18n/voice-capture-messages';

import { VoiceCaptureElement } from './components/voice-capture';

if (typeof customElements !== 'undefined' && !customElements.get('voice-capture')) {
  customElements.define('voice-capture', VoiceCaptureElement);
}

